import ApiTask from "@/api/task";
export default {
    data() {
        return {
            form: {
                title: "",
                categoryId: "",
                stationId: "",
                text: ""
            },
            rules: {
                title: [
                    { required: true, message: "Please input title", trigger: "blur" },
                ],
            },
        }
    },
    methods: {
        submitForm() {
            this.$refs.ruleFormRef.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    ApiTask.create(this.form).then((responce) => {
                        if (responce.status) {
                        } else {
                            this.loading = false;
                            this.$notify({
                                title: "Error",
                                type: "error",
                            });
                        }
                    });
                } else {
                    this.$notify({
                        title: "Error",
                        message: "Form data is invalid",
                        type: "error",
                    });
                    return false;
                }
            });
        },
    }
}